import { fetchQuery_DEPRECATED as fetchQuery, graphql } from 'react-relay/legacy';
import get from 'lodash.get';

const query = graphql`
    query fetchTradeOnboardingEligibilityQuery($userId: String!, $buyerId: [String!]) {
        viewer {
            user(userId: $userId) {
                isVerifiedTrade
                verifiedTradeSubStatus
            }
            transactions(buyerId: $buyerId, first: 1, sort: "checkoutDate desc") {
                edges {
                    node {
                        checkoutDate
                    }
                }
            }
        }
    }
`;

function isOldTransaction(transaction) {
    if (!transaction || !transaction.checkoutDate) {
        return true;
    }

    const millisecondsInSixMonths = 15552000000; // 6 * 30 * 24 * 60 * 60 * 1000;
    const transactionDate = new Date(transaction.checkoutDate);
    return transactionDate.getTime() + millisecondsInSixMonths < Date.now();
}

export const fetchTradeOnboardingEligibility = (() => {
    let queryResult = null;

    return function (relayEnvironment, userId) {
        if (queryResult) {
            return queryResult;
        }

        queryResult = fetchQuery(relayEnvironment, query, {
            buyerId: [userId],
            userId,
        }).then(response => {
            const viewer = get(response, 'viewer');
            const isVerifiedTrade = get(viewer, 'user.isVerifiedTrade');
            const isRecentTradeUser =
                get(viewer, 'user.verifiedTradeSubStatus') === 'VERIFIED_IN_LAST_30_DAYS';

            // in this case, an "inactive user" is one that has not completed a purchase in the past 6 months
            const mostRecentTransaction = get(viewer, 'transactions.edges[0].node');
            const isInactiveUser = isOldTransaction(mostRecentTransaction);

            return isVerifiedTrade && (isRecentTradeUser || isInactiveUser);
        });

        return queryResult;
    };
})();
